import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { SidebarTrigger, TooltipProvider } from '@/lib/macondo';
import { activeNavItem } from './nav';
import { UserMenu } from './UserMenu';
import { FeedbackWidget } from '@/feedback/FeedbackWidget';
import { ProductUpdatesWidget } from '@/product-updates/ProductUpdatesWidget';

export function Topbar() {
  const { pathname } = useLocation();
  const title = activeNavItem(pathname)?.label ?? 'Billing';

  return (
    <header className="border-border-primary bg-background sticky top-0 z-[30] flex h-1200 items-center gap-300 border-b px-400 md:px-600">
      <SidebarTrigger
        className="md:hidden"
        variant="ghost-square"
        size="sm"
        aria-label="Open navigation"
        icon={<Menu size={18} aria-hidden="true" />}
      />
      <h1 className="text-headline text-typography-primary truncate">{title}</h1>
      <div className="flex-1" />
      <TooltipProvider>
        <div className="flex items-center gap-100" data-slot="topbar-actions">
          <FeedbackWidget tool="billing" variant="docked" />
          <ProductUpdatesWidget variant="docked" />
          <UserMenu />
        </div>
      </TooltipProvider>
    </header>
  );
}
